/* Picura Startseite: dezentes Einblenden von .picura-reveal-Elementen.
   Elemente, die beim Laden schon sichtbar sind, bleiben unangetastet (kein Flackern, kein CLS). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(root) {
    var items = (root || document).querySelectorAll('.picura-reveal:not(.is-shown):not(.is-pending)');
    if (!items.length) return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('is-shown');
        el.classList.remove('is-pending');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return;
      el.classList.add('is-pending');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme Editor: neu geladene Sections direkt sichtbar machen */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.picura-reveal').forEach(function (el) {
      el.classList.remove('is-pending');
      el.classList.add('is-shown');
    });
  });
})();

/* Emojis aus redaktionellen Texten ausblenden (Produktbeschreibung, Seitentext, FAQ).
   Aendert nur die Anzeige, nicht die Daten in Shopify. */
(function () {
  var SEL = '.picura-desc__cols, .product-desc-2col, .product-description-below-gallery, .picura-page__inner, .picura-faq__answer, .picura-seo__inner';
  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{23E9}-\u{23FA}\u{2B00}-\u{2BFF}\u{FE0F}\u{2934}\u{2935}\u{2049}\u{203C}]/gu;
  function clean(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node, changed = [];
    while ((node = walker.nextNode())) {
      if (EMOJI.test(node.nodeValue)) changed.push(node);
      EMOJI.lastIndex = 0;
    }
    changed.forEach(function (n) {
      n.nodeValue = n.nodeValue.replace(EMOJI, '').replace(/\s{2,}/g, ' ').replace(/^\s+/, '');
    });
  }
  function run() { document.querySelectorAll(SEL).forEach(clean); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
